import { render, staticRenderFns } from "./TargetList.vue?vue&type=template&id=54c5deed&"
import script from "./TargetList.vue?vue&type=script&lang=js&"
export * from "./TargetList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports